import { NotificationState, PartialNotification } from '@/types/notifications';
import { RootState } from '@/types/store';
import { defaults } from 'lodash';
import { ActionTree, GetterTree, Module, MutationTree } from 'vuex';

type NotificationGetter = GetterTree<NotificationState, RootState>;

const state: NotificationState = {
  queue: [],
  defaults: {
    timeout: 6000,
  },
  showReload: false,
};

const getters: NotificationGetter = {
  notificationQueue: state => state.queue,
  notificationsPending: state => state.queue.length > 0,
};

const actions: ActionTree<NotificationState, RootState> = {
  addNotification({ commit }, notification: PartialNotification) {
    commit('addNotification', notification);
  },
  error({ commit }, text: string) {
    commit('addNotification', { text, colour: 'red', top: true, right: true });
  },
  success({ commit }, text: string) {
    commit('addNotification', {
      text,
      colour: 'green',
      top: true,
      right: true,
    });
  },
  shiftNotification({ commit }) {
    commit('clearNotification');
  },
};

const mutations: MutationTree<NotificationState> = {
  addNotification(state: NotificationState, notification): void {
    const item = defaults(notification, state.defaults);
    state.queue.push(item);
  },
  clearNotification(state: NotificationState): void {
    state.queue.shift();
  },
  setReloadNotification(
    state: NotificationState,
    showNotification: boolean,
  ): void {
    state.showReload = showNotification;
  },
};

const notifications: Module<NotificationState, RootState> = {
  state,
  getters,
  actions,
  mutations,
  namespaced: true,
};

export default notifications;
